"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { capturePageView } from "./capture";

/** Emits a structured page_view on every path change. Renders nothing. */
export function RouteTelemetry() {
  const pathname = usePathname();
  useEffect(() => {
    capturePageView(pathname);
  }, [pathname]);
  return null;
}
